import PropTypes from "prop-types"
import React from "react"
import {Grid} from "semantic-ui-react"
import colors from "../../../styles/_colors.module.scss"
import "./lightHeader.scss"

const EMPTY_SPAN = <span></span>

/**
 * Un header minimaliste avec 3 éléments
 */
const LightHeader = ({
    backgroundColor = colors.white,
    centerItem = EMPTY_SPAN,
    height = "auto",
    leftItem = EMPTY_SPAN,
    rightItem = EMPTY_SPAN,
    style = {},
}) => {
    return (
        <header className="light-header" style={{backgroundColor, height, minHeight: height, ...style}}>
            <Grid large="true">
                <Grid.Row>
                    <Grid.Column width={3}>{leftItem}</Grid.Column>
                    <Grid.Column width={10}>{centerItem}</Grid.Column>
                    <Grid.Column width={3}>{rightItem}</Grid.Column>
                </Grid.Row>
            </Grid>
        </header>
    )
}

LightHeader.propTypes = {
    backgroundColor: PropTypes.string,
    centerItem: PropTypes.node,
    height: PropTypes.string,
    leftItem: PropTypes.node,
    rightItem: PropTypes.node,
    style: PropTypes.object,
}

export default LightHeader
